module.exports = __webpack_public_path__ + "img/map_1791458194676_73900.072544f4.jpg";